<template>
  <div class="commonHeader">
    <button v-if="showBackBtn" class="commonHeader__back" @click="back">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 12H4M4 12L10 18M4 12L10 6"
          stroke="white"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
    <template v-if="mode === 'default'">
      <h1 class="global-page-title commonHeader__title">{{ title }}</h1>
    </template>
    <template v-if="mode === 'welcome'">
      <img v-if="logo" class="commonHeader__logo" :src="logo" alt="" />
      <h1 v-else class="global-page-title commonHeader__title">
        {{ hotelName }}
      </h1>
    </template>
    <TheLanguage class="commonHeader__language" v-if="!this.closeFunc" />
    <div v-if="closeFunc" @click="closeFunc" class="commonHeader__close">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 5L12 12M19 19L12 12M12 12L19 5L5 19"
          stroke="var(--color-text)"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>
  <teleport to="#wrapper">
    <AppCurtain
      :model-value="showLangSwitcher"
      @update:model-value="TOGGLE_LANG_SWITCHER($event)"
    >
      <template #title> {{ $t("language") }}</template>
      <template #default>
        <LangMenu :hotelData="hotelData" />
      </template>
    </AppCurtain>
  </teleport>
</template>

<script>
import TheLanguage from "@/components/common/TheLanguage";
import AppCurtain from "@/components/UI/AppCurtain";
import LangMenu from "@/components/common/LangMenu";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "TheHeader",
  components: { LangMenu, AppCurtain, TheLanguage },
  props: {
    mode: {
      type: String,
      default: "default",
    },
    title: {
      type: String,
      default: "Title",
    },
    hotelData: null,
    backPath: String,
    backFunc: Function,
    closeFunc: Function,
  },
  computed: {
    ...mapGetters({
      showLangSwitcher: "showLangSwitcher",
      reservation: "booking/reservation",
    }),
    showBackBtn() {
      return !!this.backPath || !!this.backFunc;
    },
    logo() {
      if (this.reservation) return this.reservation?.["logo"];
      return this.hotelData.logo;
    },
    hotelName() {
      return this.reservation?.["hotelName"]?.[this.$i18n.locale];
    },
  },
  methods: {
    ...mapMutations({ TOGGLE_LANG_SWITCHER: "TOGGLE_LANG_SWITCHER" }),
    back() {
      if (typeof this.backFunc !== "undefined") {
        this.backFunc();
      } else {
        this.$router.push({
          name: this.backPath,
          params: { locale: this.$i18n.locale },
          query: {
            ...this.$route.query,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss">
.commonHeader {
  padding: 0 21px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  width: calc(100% + 40px);
  margin-left: -20px;
  height: 64px;
  z-index: 2;
  background-color: var(--color-bg);
}

.incode__container .commonHeader {
  background-color: transparent;
}

.commonHeader__back {
  height: 24px;
  width: 24px;
  background-color: transparent;
  border: none;
  font-size: 0;
  position: absolute;
  left: 20px;
  padding: 0;

  svg {
    height: 24px;
    width: 24px;
  }

  svg > path {
    stroke: var(--color-text);
  }
}

.commonHeader__logo {
  max-height: 50px;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  object-fit: contain;
}

.commonHeader__title {
  color: var(--color-text);
  text-align: center;
  margin-bottom: 0;
  margin-left: auto;
  margin-right: auto;
}

.commonHeader__language {
  position: absolute;
}

@include media-breakpoint-up(sm) {
  .commonHeader {
    height: 80px;
  }
}

.commonHeader__close {
  position: absolute;
  right: 20px;
  cursor: pointer;
}
</style>
